import React, { Component } from 'react';


import formController
 from '../../../common/hoc/forms/FormController';


import {
 TextField,
 InputAdornment,
 IconButton,
 withStyles,
} from '@material-ui/core';


import {
 PersonOutline,
 LockOutlined,
 Visibility,
 VisibilityOff,
 ErrorOutline,
} from '@material-ui/icons';




const styles = {


 /* =====================================================
    FIELD
 ===================================================== */


 field: {
   marginBottom: 20,
 },




 /* =====================================================
    TEXT FIELD
 ===================================================== */


 textField: {


   '& .MuiOutlinedInput-root': {


     minHeight: 54,


     borderRadius: 12,


     background: '#f8fafc',


     transition: 'all 0.2s ease',




     '& fieldset': {
       borderColor: '#e2e8f0',
     },




     '&:hover fieldset': {
       borderColor: '#94a3b8',
     },




     '&.Mui-focused': {
       background: '#ffffff',
     },




     '&.Mui-focused fieldset': {


       borderColor: '#4f46e5',


       borderWidth: 1,
     },
   },




   '& .MuiInputLabel-outlined': {
     color: '#64748b',
   },




   '& .MuiInputLabel-outlined.Mui-focused': {
     color: '#4f46e5',
   },




   '& .MuiOutlinedInput-input': {


     fontSize: 14,


     color: '#111827',
   },
 },




 /* =====================================================
    VALIDATION ERROR
 ===================================================== */


 error: {


   display: 'block',


   minHeight: 18,


   marginTop: 5,


   color: '#dc2626',


   fontSize: 12,


   fontWeight: 500,


   lineHeight: 1.4,
 },




 /* =====================================================
    SERVER ERROR
 ===================================================== */


 serverError: {


   display: 'flex',


   alignItems: 'flex-start',


   marginBottom: 18,


   padding: '12px 14px',


   borderRadius: 10,


   background: '#fef2f2',


   border:
     '1px solid #fecaca',


   color: '#dc2626',


   fontSize: 13,


   lineHeight: 1.5,
 },




 errorIcon: {


   marginRight: 8,


   marginTop: 1,


   fontSize: 18,


   flexShrink: 0,
 },




 inputIcon: {


   color: '#94a3b8',


   fontSize: 21,
 },




 passwordButton: {


   color: '#64748b',


   padding: 5,


   '&:hover': {
     background: 'rgba(79,70,229,0.06)',
   },
 },
};




class LoginForm extends Component {


 constructor(props) {


   super(props);


   this.state = {
     showPassword: false,
   };
 }




 /* =====================================================
    TOGGLE PASSWORD
 ===================================================== */


 togglePassword = () => {


   this.setState({
     showPassword:
       !this.state.showPassword,
   });
 };




 render() {


   const {
     model,
     errors,
     onModelChange,
     validator,
     classes,
   } = this.props;




   const {
     showPassword,
   } = this.state;




   return (


     <React.Fragment>


       {/* =================================================
           USERNAME
       ================================================= */}


       <div className={classes.field}>


         <TextField


           fullWidth


           variant="outlined"


           label="Username"


           placeholder="Enter your username"


           name="userEmail"


           value={
             model.userEmail || ''
           }


           onChange={
             onModelChange
           }


           autoComplete="username"


           className={
             classes.textField
           }


           InputProps={{


             startAdornment: (


               <InputAdornment
                 position="start"
               >


                 <PersonOutline
                   className={
                     classes.inputIcon
                   }
                 />


               </InputAdornment>


             ),
           }}


         />




         {/* VALIDATION */}


         <small
           className={
             classes.error
           }
         >


           <b>


             {validator.message(
               'username',
               model.userEmail,
               'required'
             )}


           </b>


         </small>


       </div>




       {/* =================================================
           PASSWORD
       ================================================= */}


       <div className={classes.field}>


         <TextField


           fullWidth


           variant="outlined"


           label="Password"


           placeholder="Enter your password"


           name="password"


           type={
             showPassword
               ? 'text'
               : 'password'
           }


           value={
             model.password || ''
           }


           onChange={
             onModelChange
           }


           autoComplete="current-password"


           className={
             classes.textField
           }


           InputProps={{


             /* USER ICON */


             startAdornment: (


               <InputAdornment
                 position="start"
               >


                 <LockOutlined
                   className={
                     classes.inputIcon
                   }
                 />


               </InputAdornment>


             ),




             /* SHOW / HIDE PASSWORD */


             endAdornment: (


               <InputAdornment
                 position="end"
               >


                 <IconButton


                   edge="end"


                   size="small"


                   className={
                     classes.passwordButton
                   }


                   onClick={
                     this.togglePassword
                   }


                   aria-label={
                     showPassword
                       ? 'Hide password'
                       : 'Show password'
                   }


                 >


                   {showPassword ? (


                     <VisibilityOff />


                   ) : (


                     <Visibility />


                   )}


                 </IconButton>


               </InputAdornment>


             ),
           }}


         />




         {/* VALIDATION */}


         <small
           className={
             classes.error
           }
         >


           <b>


             {validator.message(
               'password',
               model.password,
               'required'
             )}


           </b>


         </small>


       </div>




       {/* =================================================
           SERVER ERROR
       ================================================= */}


       {
         errors &&
         errors.message && (


           <div
             className={
               classes.serverError
             }
           >


             <ErrorOutline
               className={
                 classes.errorIcon
               }
             />


             <span>
               {errors.message}
             </span>


           </div>


         )
       }


     </React.Fragment>
   );
 }
}




export default withStyles(styles)(
 formController(LoginForm)
);

